import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { RadioButtonModule, TabViewModule } from 'primeng/primeng';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BestheaderComponent } from './bestheader/bestheader.component';
import { AddmemberComponent } from './components/addmember/addmember.component';
import { AddressformComponent } from './components/addressform/addressform.component';

import { AddonmemberComponent } from './components/addonmember/addonmember.component';
import { MemberPrintComponent } from './components/member-print/member-print.component';
import { OtpComponent } from './components/otp/otp.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxBarcodeModule } from 'ngx-barcode';
import {
  MatCardModule,
  MatInputModule,
  MatStepperModule,
  MatRadioModule,
  MatSelectModule,
  MatFormFieldModule,
  MatCheckboxModule,
  MatExpansionModule,
  MatTabsModule,
  MatTableModule,
  MatPaginatorModule,
  MatIconModule
} from '@angular/material';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MatButtonModule } from '@angular/material/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartsModule } from 'ng2-charts';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RevokepageComponent } from './components/revokepage/revokepage.component';
import { UpdatecontactComponent } from './components/updatecontact/updatecontact.component';
import { StatusPipe } from './pipes/status.pipe';
import { Api } from './services/api';
import { CardModule } from 'primeng/card';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ViewmemberComponent } from './components/viewmember/viewmember.component';
import { JsonFilterPipe } from './pipes/json-filter.pipe';
import { SelectFilterPipe } from './pipes/select-filter.pipe';

import { DocuploadComponent } from './components/docupload/docupload.component';
import { MembershipInitiatedComponent } from './components/membership-initiated/membership-initiated.component';
import { DatePipe } from '@angular/common';
import { TermConditionComponent } from './components/term-condition/term-condition.component';
import { DigitalDeclarationComponent } from './components/digitaldeclaration/digitaldeclaration.component';
import { SearchFilterPipe } from './pipes/search-filter-pipe.pipe';
import { ImagepreviewComponent } from './components/imagepreview/imagepreview.component';


import { BestheadererComponent } from './bestheaderer/bestheaderer.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TableModule } from 'primeng/table';
import { OtppopupComponent } from './components/otppopup/otppopup.component';
import { EcardComponent } from './components/ecard/ecard.component';
import { InfoformComponent } from './components/infoform/infoform.component';
import { DetailformComponent } from './components/detailform/detailform.component';
import { CardholderformComponent } from './components/cardholderform/cardholderform.component';
import { MembersauditlogComponent } from './components/membersauditlog/membersauditlog.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DuplicateLicenseComponent } from './components/duplicate-license/duplicate-license.component';
import { WebcamComponent } from './components/webcam/webcam.component';
import { WebcamModule } from 'ngx-webcam';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RedirectComponent } from './components/redirect/redirect.component';
import { MatProgressSpinnerModule } from '@angular/material';

import { SubmitpageComponent } from './components/submitpage/submitpage.component';

import { SendsmsComponent } from './components/sendsms/sendsms.component';

import { ImgpopupComponent } from './components/imgpopup/imgpopup.component';
import { AuthserviceComponent } from './components/authservice/authservice.component';

import { PurchasehistoryComponent } from './components/purchasehistory/purchasehistory.component';
import { TrackappComponent } from './components/trackapp/trackapp.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxScrollToFirstInvalidModule } from '@ismaestro/ngx-scroll-to-first-invalid';
import { MemberRevokeComponent } from './components/memberrevoke/memberrevoke.component';
import { MembershipSearchComponent } from './components/membership-search/membership-search.component';
import { ApkinstallerComponent } from './components/apkinstaller/apkinstaller.component';
import { FaqComponent } from './components/faq/faq.component';
import { MultipleaddressComponent } from './components/multipleaddress/multipleaddress.component';
import { MobilenumberupdateComponent } from './components/mobilenumberupdate/mobilenumberupdate.component';


@NgModule({
  declarations: [
    AppComponent,
    AddmemberComponent,
    ViewmemberComponent,
    OtpComponent,
    AddressformComponent,
    AddonmemberComponent,
    JsonFilterPipe,
    SelectFilterPipe,
    SelectFilterPipe,
    DocuploadComponent,
    MembershipInitiatedComponent,
    TermConditionComponent,
    DigitalDeclarationComponent,
    SearchFilterPipe,
    OtppopupComponent,
    EcardComponent,
    InfoformComponent,
    DetailformComponent,
    CardholderformComponent,
    MembersauditlogComponent,
    DuplicateLicenseComponent,
    WebcamComponent,
    BestheadererComponent,
    BestheaderComponent,
    ImagepreviewComponent,
    RedirectComponent,

    SubmitpageComponent,
    SendsmsComponent,
    ImgpopupComponent,
    AuthserviceComponent,
    
    PurchasehistoryComponent,
    TrackappComponent,
    StatusPipe,
    RevokepageComponent,
    MemberPrintComponent,
    UpdatecontactComponent,    
    MemberRevokeComponent,
    MembershipSearchComponent,
    ApkinstallerComponent,
    FaqComponent,
    MultipleaddressComponent,
    MobilenumberupdateComponent
  ],
  imports: [
    BrowserModule,
    MatButtonModule,
    AppRoutingModule,
    SplitButtonModule,
    BrowserAnimationsModule,
    MatCardModule,
    ToastModule,
    DropdownModule,
    MatStepperModule,
    DialogModule,
    FormsModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    MatRadioModule,
    AccordionModule,
    MatFormFieldModule,
    ProgressSpinnerModule,
    MatInputModule,
    MatSelectModule,
    OverlayPanelModule,
    MatCheckboxModule,
    FileUploadModule,
    MultiSelectModule,
    CalendarModule,
    MatExpansionModule,
    MatTabsModule,
    MatTableModule,
    TableModule,
    MatPaginatorModule,
    PaginatorModule,
    ChartModule,
    TooltipModule,
    MatIconModule,
    ChartsModule,
    HttpClientModule,
    DropdownModule,
    KeyFilterModule,
    DynamicDialogModule,
    CardModule,
    PdfViewerModule,
    WebcamModule,
    MatProgressSpinnerModule,
    RadioButtonModule,
    TabViewModule,
    NgxScrollToFirstInvalidModule,
    NgxBarcodeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [Api, MessageService, DatePipe, ConfirmationService],
  bootstrap: [AppComponent],
  entryComponents: [
    AddonmemberComponent,
    OtpComponent,
    TermConditionComponent,
    DigitalDeclarationComponent,
    ImagepreviewComponent,
    OtppopupComponent,
    InfoformComponent,
    DetailformComponent,
    CardholderformComponent,
    MembersauditlogComponent,
    DuplicateLicenseComponent,
    WebcamComponent,
    AddressformComponent,
    PurchasehistoryComponent,
    ImgpopupComponent,
    MemberPrintComponent,
    UpdatecontactComponent,
    MemberRevokeComponent,
    MultipleaddressComponent,
    MobilenumberupdateComponent
  ]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
